export default "__VITE_ASSET__BqiwoZgR__"